export interface HelpLink {
  labelTranslateKey: string;
  url: string;
}

export const helpLinks = {
  knowledgeBase: {
    labelTranslateKey: 'header.knowledge-base',
    url: 'https://help.one.kaseya.com/help/Default_CSH.htm#1000',
  },
  status: {
    labelTranslateKey: 'header.status',
    url: 'https://status.kaseya.net',
  },
  releaseNotes: {
    labelTranslateKey: 'header.release-notes',
    url: 'https://help.one.kaseya.com/help/Default_CSH.htm#1011',
  },
  kaseyaInnovations: {
    labelTranslateKey: 'header.kaseya-innovations',
    url: 'https://www.kaseya.com/innovations',
  },
  legalTerms: {
    labelTranslateKey: 'header.legal-terms',
    url: 'https://www.kaseya.com/legal/',
  },
  legalTermsArchive: {
    labelTranslateKey: 'header.legal-terms-archive',
    url: '/legal-terms-archive',
  },
};
